import moment from "moment";
import { InputSwitch } from "primereact/inputswitch";
import React, { Fragment, useContext } from "react";
import { TIME_ZONE } from "../../../../constants";
import { useMutation } from "react-query";
import { IsLoadingResponse } from "../../../../utils/Helper";
import DataTabel from "../../../../reuseable/DataTabel";
import { TABEL_UNIQUE_ID } from "../../../../constants/RoutingConstants/RoutingConstants";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import Actions from "../../../../layouts/Actions";
import UserContext from "../../../../context/UserContext/UserContext";
import {
  DELETE_Customer_Post,
  Enable_Disable_Customer_Post,
  Get_Details_Customer_Post,
} from "../../../../Apis/customerPostApi/customerPostApi";
import CustomerPostContext from "../../../../context/CustomerPostContext /CustomerPostContext ";

const CustomerPostDataTableContainer = (props) => {
  const {
    filter,
    setFilter,
    record,
    pageSize,
    page,
    setPageSize,
    setPage,
    setFormData,
    setDialogs,
    setOrgId,
    setIsEdit,
    setSortBy,
    setSortOrder,
    sortOrder,
  } = useContext(CustomerPostContext);
  const { orgDetails } = useContext(UserContext);
  const { isLoading, data, handleOpenandClosePopup, refetch } = props;

  /**
   * get CustomePost Details
   */
  const { mutate: CustomePostDetails, isLoading: isLoadingCompanyDetails } =
    useMutation((customerPostId) =>
      Get_Details_Customer_Post(customerPostId, setFormData, setDialogs)
    );

  const GetCompanyPostDetails = (customerPostId) => {
    CustomePostDetails(customerPostId);
    setOrgId(customerPostId);
    setIsEdit(false);
  };

  /**
   * delete CustomePost
   */
  const { mutate: CustomePostDelete, isLoading: isLoadingDelete } = useMutation(
    (customerPostId) => DELETE_Customer_Post(customerPostId, refetch)
  );

  const DeleteCompany = async (customerPostId) => {
    SweetConfirmation(CustomePostDelete, customerPostId);
  };

  /**
   * enable / disable CustomePost
   */

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    Enable_Disable_Customer_Post(formData, refetch)
  );

  const handleCustomerStatusChange = (customerPostId, status) => {
    let formDate = {
      customerPostId: customerPostId,
      isActive: status ? false : true,
    };

    data.payload.data = data.payload.data.map((row) => {
      if (row.customerPostId === customerPostId) {
        return {
          ...row,
          isActive: status ? false : true,
        };
      } else {
        return row;
      }
    });
    statusChangeMutate(formDate);
  };

  /**
   *
   * @param {Sorting obj} col
   * Table Sorting
   */

  const sorting = (col) => {
    if (sortOrder === "") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("ASC");
    }
    if (sortOrder === "ASC") {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder("DSC");
    }
    if (sortOrder === "DSC") {
      setSortBy();
      setSortOrder("");
    }
  };

  const defaultColumns = [
    {
      flex: 0.1,
      minWidth: 120,
      field: "url",
      headerName: "Url",
      renderCell: (params) => (
        // params.row.logo ? params.row.logo : "--"
        <div className="flex justify-content-center ">
          <img
            className="img-thumbnail"
            src={params.row.url}
            alt=""
            width={50}
          />
        </div>
      ),
    },
    {
      flex: 0.1,
      minWidth: 250,
      field: "postType",
      headerName: "Post Type",
      renderCell: (params) =>
        params.row.postType ? params.row.postType : "--",
    },
    {
      flex: 0.1,
      minWidth: 180,
      field: "scheduleDate",
      headerName: "Schedule Date",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.scheduleDate)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      renderCell: (params, index) => (
        <div className="flex justify-content-center">
          <InputSwitch
            checked={params.row.isActive === true}
            onChange={() =>
              handleCustomerStatusChange(
                params.row.customerPostId,
                params.row.isActive
              )
            }
          />
        </div>
      ),
    },

    {
      flex: 0.1,
      minWidth: 180,
      field: "createdAt",
      headerName: "CreatedAt",
      sortable: false,
      renderCell: (params) =>
        moment(params.row.createdAt)
          .utcOffset(TIME_ZONE)
          .format("DD MMM, YYYY hh:mm"),
    },
    {
      flex: 0.1,
      minWidth: 100,
      field: "actions",
      headerName: "Actions",
      sortable: false,

      renderCell: (params) => (
        <>
          <Actions
            id={params.row.customerPostId}
            getDetails={GetCompanyPostDetails}
            deleteDetails={DeleteCompany}
            removeDelete={orgDetails?.companyLimit > 1}
          />
        </>
      ),
    },
  ];
  return (
    <Fragment>
      <IsLoadingResponse
        isLoading={isLoadingCompanyDetails || isLoadingDelete}
      />

      <DataTabel
        filter={filter}
        setFilter={setFilter}
        handleOpenandClosePopup={handleOpenandClosePopup}
        data={data}
        defaultColumns={defaultColumns}
        record={record}
        pageSize={pageSize}
        page={page}
        setPageSize={setPageSize}
        setPage={setPage}
        sorting={sorting}
        isLoading={isLoading}
        sortOrder={sortOrder}
        setSortBy={setSortBy}
        setSortOrder={setSortOrder}
        id={TABEL_UNIQUE_ID.customerPostId}
        addButton={true}
      />
    </Fragment>
  );
};

export default CustomerPostDataTableContainer;
